import * as api from '../api/posts';

// Actions Creators
export const getPosts = () => async (dispatch) => {
    try {
        const { data } = await api.fetchPosts();
        
        dispatch({ type: 'FETCH_ALL_POST', payload: data });
        
    } catch (error) {
        console.log(error)
    }
}

// export const getPostTags = (id) => async (dispatch) => {
//     try {
//         const { data } = await api.fetchPostTags(id);

//         dispatch({ type: 'FETCH_POST_TAGS', payload: data });

//     } catch (error) {
//         console.log(error)
//     }
// }

export const getPost = (post) => async (dispatch) => {

    try {
        dispatch({ type: 'GET_POST', payload: post });

    } catch (error) {
        console.log(error)
    }
} 
    
export const createPosts = (post) => async (dispatch) => {

    try {
        const { data } = await api.createPosts(post);

        dispatch({ type: 'CREATE_POST', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const updatePost = (id, post) => async (dispatch) => {
    try {
        const { data } = await api.updatePost(id, post);

        dispatch({ type: 'UPDATE_POST', payload: data });

    } catch (error) {
        console.log(error)
    }
}

export const deletePost = (id) => async (dispatch) => {
    try {
        await api.deletePost(id);

        dispatch({ type: 'DELETE_POST', payload: id });

    } catch (error) {
        console.log(error)
    }
}
